import { Component, EventEmitter, Input, OnInit, Output, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Capability } from '../../models/service/capability';
import { MatDialog } from '@angular/material/dialog';
import { CapabilityDetailsComponent } from 'src/app/components/capability-details/capability-details.component';
import { CapabilitiesService } from 'src/app/services/api/capabilities.service';


@Component({
    selector: 'app-capability-card',
    templateUrl: './capability-card.component.html',
    styleUrls: ['./capability-card.component.scss'],
    standalone: false
})
export class CapabilityCardComponent  implements OnInit {

  @Input() capability: Capability;
  @Input() showLink = true;
  @Input() selectable = true;
  @Input() isUpdated = true;
  @Input() capabilityDescription: Capability[];
  @Output() selectionChanged = new EventEmitter();
  private destroyRef = inject(DestroyRef);

  constructor(private matDialog: MatDialog, private capabilitiesService: CapabilitiesService) {
    
  }

  ngOnInit(): void {
  //TODO: Below code required to enable and modify when extend sandbox / service is enabled.
    /*if (this.isUpdated) {
      this.capability.selected = this.isUpdated;
    }*/
  }

  toggleSelection(): void {
    this.capability.selected = !this.capability.selected;
    this.selectionChanged.emit(this.capability);
  }

  async viewDetails(): Promise<void> {
    (await this.capabilitiesService.getCapabilitiesView({ name: this.capability.name, version: this.capability.version }))
    .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
        this.viewDetailsDescription(response);
    });
  }

  viewDetailsDescription(response): void {
    if(response) {
      this.matDialog.open(CapabilityDetailsComponent, {
        minHeight: '533px',
        width: '760px',
        panelClass: 'flex-dialog',
        data: {
          capability: this.capability,
          selectable: this.selectable,
          capabiltyDisabled: this.capability.disabled,
          description: response.description,
          version: response.version,
          releaseVersion: response.releaseVersion,
          isAMR: response.isAMR
        }
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if (result) {
          this.selectionChanged.emit(this.capability);
        }
      });
    }
  }
}
